import React from 'react';

const TestPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-purple-50 p-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Navigation Test Page</h1>
          <p className="text-gray-600 mb-6">
            This is a test page to verify that navigation is working correctly.
          </p>
          <div className="bg-green-100 border border-green-200 rounded-lg p-4">
            <h2 className="text-lg font-semibold text-green-800 mb-2">✅ Navigation Working!</h2>
            <p className="text-green-700">
              If you can see this page, it means the navigation tabs are working correctly.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestPage;
